<template>
  <v-dialog v-model="dialogOpen" width="600" persistent>
    <v-card>
      <v-card-title>Scheduler</v-card-title>
      <v-tabs v-model="tab">
        <v-tab>Single Run</v-tab>
        <v-tab>Recurring (coming soon)</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card-text>
            <v-form ref="singleForm">
              <v-row>
                <v-col cols="12" md="6">
                  <v-menu ref="dateMenuRef" v-model="dateMenu" :close-on-content-click="false" :return-value.sync="runDate" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="runDate" label="Run Date" prepend-icon="far fa-calendar-day" readonly v-on="on" :rules="[v => !!v || 'Required']"></v-text-field>
                    </template>
                    <v-date-picker v-model="runDate" no-title scrollable>
                      <div class="flex-grow-1"></div>
                      <v-btn text color="primary" @click="dateMenu = false">Cancel</v-btn>
                      <v-btn text color="primary" @click="$refs.dateMenuRef.save(runDate)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6">
                  <time-select v-model="runTime" label="Run Time" :rules="[v => !!v || 'Required']"></time-select>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-text>
            <v-form ref="recurForm">
              <v-select v-model="interval" :items="recurrenceOptions" label="Recurrence Inverval"></v-select>
              <v-row>
                <v-col v-if="intervalOptions.length > 0">
                  <v-select v-model="recurrenceValue" :items="intervalOptions" multiple label="When to run"></v-select>
                </v-col>
                <v-col>
                  <time-select v-model="runTime" label="Time of day"></time-select>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
      <v-card-actions>
        <v-btn text @click="cancel">Cancel</v-btn>
        <v-btn text @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { ref, computed } from '@vue/composition-api'

export default {
  components: {
    TimeSelect: () => import('./schedule/TimeSelect')
  },
  props: {
    dialogOpen: {
      type: Boolean,
      required: true
    }
  },
  setup (props, { emit }) {
    const tab = ref(0)
    const runDate = ref('')
    const dateMenu = ref(false)
    const dateMenuRef = ref(null)
    const runTime = ref('')
    const interval = ref('')
    const recurrenceValue = ref('')
    const recurrenceOptions = ref([
      { text: 'Daily', value: 'day' },
      { text: 'Weekly', value: 'week' },
      { text: 'Each Pay Period', value: 'ptrcaln' },
      { text: 'Monthly', value: 'month' },
      { text: 'Quarterly', value: 'quarter' },
      { text: 'Each Fall/Spring Semester', value: 'term' },
      { text: 'Annually', value: 'year' }
    ])
    const times = ref([])

    const intervalOptions = computed(() => {
      switch (interval.value) {
        case 'week':
          return [
            { text: 'Sunday', value: '0' },
            { text: 'Monday', value: '1' },
            { text: 'Tuesday', value: '2' },
            { text: 'Wednesday', value: '3' },
            { text: 'Thursday', value: '4' },
            { text: 'Friday', value: '5' },
            { text: 'Saturday', value: '6' }
          ]
        case 'ptrcaln':
          return [
            { text: 'First Monday', value: 'start+Mon' },
            { text: 'First Tuesday', value: 'start+Tue' },
            { text: 'Last Monday', value: 'last-Mon' },
            { text: 'Last Tuesday', value: 'last-Tue' },
            { text: 'Last Wednesday', value: 'last-Wed' },
            { text: 'Last Thursday', value: 'last-Thu' },
            { text: 'Last Friday', value: 'last-Fri' },
            { text: 'Monday After End', value: 'last+Mon' },
            { text: 'Tuesday After End', value: 'last+Tue' }
          ]
        case 'month':
          return [
            { text: 'First day of month', value: 'start' },
            { text: 'First Monday of month', value: 'start+Mon' },
            { text: 'First Friday of month', value: 'start+Fri' },
            { text: 'First weekday of month', value: 'start+weekday' },
            { text: 'Last day of month', value: 'last' },
            { text: 'Last Monday of month', value: 'last-Mon' },
            { text: 'Last Friday of month', value: 'last-Fri' },
            { text: 'Last weekday of month', value: 'last-weekday' }
          ]
        case 'quarter':
          return [
            { text: 'First day of quarter', value: 'start' },
            { text: 'First Monday of quarter', value: 'start+Mon' },
            { text: 'First Friday of quarter', value: 'start+Fri' },
            { text: 'First weekday of quarter', value: 'start+weekday' },
            { text: 'Last day of quarter', value: 'last' },
            { text: 'Last Monday of quarter', value: 'last-Mon' },
            { text: 'Last Friday of quarter', value: 'last-Fri' },
            { text: 'Last weekday of quarter', value: 'last-weekday' }
          ]
        case 'term':
          return [
            { text: 'Monday before start of term', value: 'start-Mon' },
            { text: 'Tuesday before start of term', value: 'start-Tue' },
            { text: '7 days before start of term', value: 'start-7' },
            { text: 'day before start of term', value: 'start-1' },
            { text: 'start of term', value: 'start' },
            { text: 'day after start of term', value: 'start+1' },
            { text: 'Friday after start of term', value: 'start+Fri' },
            { text: 'Monday after start of term', value: 'start+Mon' },
            { text: '7 days after start of term', value: 'start+7' },
            { text: 'Monday before end of term', value: 'end-Mon' },
            { text: 'Tuesday before end of term', value: 'end-Tue' },
            { text: '7 days before end of term', value: 'end-7' },
            { text: 'end of term', value: 'end' },
            { text: 'day after end of term', value: 'end+1' },
            { text: 'Monday after end of term', value: 'end+Mon' },
            { text: 'Friday after end of term', value: 'end+Fri' },
            { text: '7 days after end of term', value: 'end+7' }
          ]
        case 'year':
          return [
            { text: 'January 1', value: 'Jan01' },
            { text: 'First workday of year', value: 'Jan01+workday' },
            { text: 'June 30', value: 'Jun30' },
            { text: 'Last workday of fiscal year', value: 'JUN30-workday' },
            { text: 'July 1', value: 'Jul01' },
            { text: 'First workday of fiscal year', value: 'Jul01+workday' },
            { text: 'December 31', value: 'Dec31' },
            { text: 'Last workday of calendar year', value: 'Dec31-workday' }
          ]
      }
      return []
    })

    const singleForm = ref(null)
    const recurForm = ref(null)

    function cancel () {
      emit('close')
    }

    function save () {
      if (tab.value === 0) {
        // single occurence
        if (singleForm.value.validate()) {
          if (runDate.value === '' || runTime.value === '') {
            if (runDate.value === '' && runTime.value === '') alert('You must select the date and time before scheduling will work')
          } else {
            let date = new Date(runDate.value + ' ' + runTime.value)
            this.$emit('save', { runDate: date })
          }
        }
      }
    }

    return {
      tab,
      runDate,
      dateMenu,
      dateMenuRef,
      runTime,
      interval,
      intervalOptions,
      recurrenceValue,
      recurrenceOptions,
      times,
      singleForm,
      recurForm,
      cancel,
      save
    }
  }
}
</script>
